<template>
  <div class="insight-optin-main-banner">
    <img :src="optinMainBanner" alt="Optin Main Banner" />
    <div class="insight-optin-main-banner__content">
      <div class="titulo">O QUE O AGENTE DE DRE FAZ</div>
      <div class="items">
        <div class="item" v-for="item in items" :key="item.icon">
          <div class="item__icon">
            <MaterialIcon :icon="item.icon" />
          </div>
          <div class="item__title">
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";
import optinMainBanner from "@/ui/assets/financas/insigths/insigthsIABanner.png";

const items = [
  {
    icon: "timeline",
    title: "Antecipação de problemas financeiros"
  },
  {
    icon: "frame_inspect",
    title: "Identificação automática de gastos fora do padrão"
  },
  {
    icon: "target",
    title: "Melhor planejamento estratégico"
  }
];
</script>

<style scoped lang="scss">
.insight-optin-main-banner {
  background-color: _map.get($map: $azulPrincipal, $key: 50);
  border-radius: 5px;
  padding: 5px 24px;
  display: flex;
  height: 100px;
  width: stretch;
  gap: 16px;

  img {
    width: 105px;
    height: 105px;
    object-fit: contain;
  }

  &__content {
    display: flex;
    align-items: left;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    gap: 8px;

    .titulo {
      font-size: 12px;
      font-weight: 700;
      color: _map.get($map: $azulPrincipal, $key: 700);
    }

    .items {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;
      gap: 25px;
      width: 100%;

      .item {
        display: flex;
        align-items: center;
        gap: 8px;

        &__icon {
          width: 24px;
          height: 24px;
          background-color: _map.get($map: $azulPrincipal, $key: 100);
          border-radius: 5px;
          padding: 4px;
          color: _map.get($map: $azulPrincipal, $key: 700);
        }

        &__title {
          font-family: "Plus Jakarta Sans", sans-serif;
          font-weight: 400;
          font-size: 14px;
          color: _map.get($map: $neutro, $key: 900);
        }
      }
    }
  }
}

@media (max-width: 920px) {
  .insight-optin-main-banner {
    img {
      display: none;
    }

    flex-direction: column;
    height: auto;
    padding: 16px;

    &__content {
      .titulo {
        font-size: 14px;
      }

      .items {
        flex-direction: column;
        gap: 8px;
      }

      .item {
        &__icon {
          width: 20px;
          height: 20px;
        }
      }

      &__title {
        font-size: 12px;
      }
    }
  }
}
</style>
